function OurExpertise() {
  return (
    <>
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="index.html">Home</a></li>
              <li className="current">Our Expertise</li>
            </ol>
          </nav>
          <h1>Our Expertise</h1>
        </div>
      </div>

      <section id="expertise" className="team section">
        <div className="container">
          <p>
            At CA Sanjay Prasad & Associates, our expertise spans a wide array of financial and business services. We specialize in providing strategic guidance and tailored solutions across key domains such as accounting, taxation, auditing, GST compliance, business advisory, and regulatory consulting. Our deep industry knowledge and hands-on experience enable us to assist clients in navigating complex financial landscapes with clarity and confidence.
          </p>
          <p>
            From startups to established enterprises, our team delivers value-driven insights to enhance operational efficiency, ensure statutory compliance, and foster long-term financial stability. We pride ourselves on being proactive partners in your growth, offering reliable support at every stage of your business journey.
          </p>
        </div>
      </section>
    </>
  );
}

export default OurExpertise;
